export default __webpack_public_path__ + "img/2903242aaa40fbb020748d8ec0dff50d.svg";